import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent implements OnInit {

  language = JSON.parse(localStorage.getItem('language'))

  @Input()
  currentPage = 1

  @Input()
  totalPage = 0

  @Input()
  isEn = false

  @Output()
  currentPageNumber = new EventEmitter()

  constructor() { }

  ngOnInit() {
    this.currentPageNumber.emit(this.currentPage)

    if(localStorage.getItem('language_flag')=='en'){
      this.isEn = true
    }else if (localStorage.getItem('language_flag')=='th'){
      this.isEn = false
    }
  }

  increasePageNumber() {
    this.currentPage++    
    this.currentPageNumber.emit(this.currentPage)
  }
  decreasePageNumber() {
    this.currentPage--
    this.currentPageNumber.emit(this.currentPage)
  }

}
